<script>
  import { isDev, Link } from '$client';
  export let data = {};

  $: if (!data.length && isDev()) data = { '/': 'Главная', '/page': 'Страница', '/page/page': 'Глубокая страница' };
</script>

{#if data.length > 1}
  <nav class="container">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      {#each data as [location, translate], index}
        <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <Link href={location}><span itemprop="name">{translate}</span></Link>
          <meta itemprop="position" content={index + 1} />
          <link itemscope itemtype="https://schema.org/WebPage" itemid={location} itemprop="item" href={location} />
        </li>
      {/each}
    </ol>
  </nav>
{/if}

<style lang="scss">
  nav {
    overflow: auto hidden;
  }

  ol {
    display: inline-flex;
    gap: 11px;
    margin-top: 30px;

    :global(a),
    :global(div) {
      color: #2c333c;
      font-size: 14px;
      font-family: Vela Sans;
      font-style: normal;
      white-space: nowrap;
    }

    :global(a:hover) {
      color: #22eaac;
    }

    :global(a::after) {
      margin-left: 11px;
      color: #2c333c;
      font-weight: normal;
      font-size: 14px;
      font-family: Vela Sans;
      font-style: normal;
      content: '/';
    }

    @media only screen and (max-width: 991.98px) {
      :global(a),
      :global(div) {
        font-size: 16px;
      }

      :global(a::after) {
        font-size: 16px;
      }
    }
  }
</style>
